import { render, staticRenderFns } from "./WorkplacesList.vue?vue&type=template&id=5b257a2e&scoped=true&"
import script from "./WorkplacesList.vue?vue&type=script&lang=js&"
export * from "./WorkplacesList.vue?vue&type=script&lang=js&"
import style0 from "./WorkplacesList.vue?vue&type=style&index=0&id=5b257a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b257a2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VTextField})
